const checkTempContractShift = shift => {
  const { user, accountId } = shift
  let matchedContracts = null
  if (user.tempContract && user.tempContract.length) {
    matchedContracts = user.tempContract.filter(contract => contract.accountId === accountId).filter(contract => contract.startDate.toDate() <= shift.start && contract.endDate.toDate() >= shift.end)
  }
  return matchedContracts && matchedContracts.length > 0 ? matchedContracts[0] : null
}

export default checkTempContractShift
